import Select from "@8x8/oxygen-select";
import { flexRender } from "@tanstack/react-table";
import React, { useCallback } from "react";
import { getFilterFns } from "@/react/components/table/useTableFilters";
import {
  FilterActionsContainer,
  FilterComponentsContainer,
  FilterContainer,
  FilterSelectWrapper,
  RemoveFilterButton,
} from "@/react/components/table/components/filter/styles";
import { TrashIcon } from "@8x8/oxygen-icon/icons";

const mapFilterFnToSelect = ([id, filter]) => ({
  value: id,
  label: filter.label,
});

export function DisplayFilter({
  headerRender,
  displayFilter,
  filterFn,
  setFilterFnId,
  setFilterValue,
  removeFilter,
}) {
  const filterFns = getFilterFns(displayFilter);
  const filterFnOptions = Array.from(filterFns.entries()).map(
    mapFilterFnToSelect
  );

  const onFilterFnChange = useCallback(
    (selectedFilterFnOption) => {
      setFilterFnId(displayFilter, selectedFilterFnOption.value);
    },
    [displayFilter, setFilterFnId]
  );
  return (
    <FilterContainer>
      <FilterActionsContainer>
        <small>{headerRender}</small>
        <FilterSelectWrapper>
          <Select
            value={{
              value: displayFilter.filterFnId,
              label: filterFn.label,
            }}
            options={filterFnOptions}
            onChange={onFilterFnChange}
            isClearable={false}
            size="small"
          />
        </FilterSelectWrapper>
        <RemoveFilterButton
          onClick={() => removeFilter(displayFilter)}
          variant="tertiary"
          size="small"
        >
          <TrashIcon size={18} />
        </RemoveFilterButton>
      </FilterActionsContainer>
      {filterFn.filterComponent && (
        <FilterComponentsContainer>
          {flexRender(filterFn.filterComponent, {
            filterValue: displayFilter.value,
            setFilterValue: setFilterValue(displayFilter),
            column: displayFilter.column,
          })}
        </FilterComponentsContainer>
      )}
    </FilterContainer>
  );
}
